import React, { useState } from "react";
import { HiCheckCircle, HiXCircle, HiChevronDown } from 'react-icons/hi';

const FullHomeCleaningInfo = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        { 
            question: "Is this service applicable for all types of homes?", 
            answer: "Yes, our tailored approach works perfectly for studio apartments, multi-story independent houses, and luxury villas. We bring specialized equipment suited for various floorings and architecture." 
        },
        { 
            question: "Will the cleaners move heavy furniture?", 
            answer: "Our professionals move lightweight furniture (chairs, side tables) to clean underneath. For heavy or built-in items, we clean the surrounding areas and underneath using specialized slim-nozzle vacuums." 
        },
        { 
            question: "How long does a full home deep clean take?", 
            answer: "Depending on the square footage, a comprehensive deep clean usually takes between 4 to 6 hours for a standard 3BHK home." 
        }
    ];

    const included = [
        "Dusting & Polishing - Detailed treatment of furniture, electronics, and decor",
        "Deep Vacuuming - Industrial-grade extraction for carpets, rugs, and sofas",
        "Floor Sterilization - Multi-stage mopping with eco-friendly sanitizers",
        "Kitchen Deep Clean - Degreasing of surfaces, exteriors, and cabinets",
        "Bathroom Sanitization - Complete disinfection of all sanitary features",
        "Glass & Window Polish - Streak-free treatment of all accessible glass"
    ];

    const excluded = [
        "Heavy debris removal from attics or storage basements",
        "Exterior facade cleaning requiring scaffolding or ropes",
        "Removal of toxic chemicals or hazardous waste materials"
    ];

    return (
        <div className="space-y-12">
            {/* Included / Excluded Grid */}
            <div className="grid md:grid-cols-2 gap-8">
                <div className="card-premium p-8 border-l-4 border-l-primary">
                    <h3 className="text-xl font-black text-foreground mb-6 uppercase tracking-widest text-sm text-primary">Full Coverage</h3>
                    <ul className="space-y-4">
                        {included.map((item, i) => (
                            <li key={i} className="flex gap-4 text-sm text-muted-foreground leading-relaxed">
                                <HiCheckCircle className="text-primary shrink-0" size={20} />
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="card-premium p-8 border-l-4 border-l-destructive/30">
                    <h3 className="text-xl font-black text-foreground mb-6 uppercase tracking-widest text-sm">Out of Scope</h3>
                    <ul className="space-y-4">
                        {excluded.map((item, i) => (
                            <li key={i} className="flex gap-4 text-sm text-muted-foreground leading-relaxed">
                                <HiXCircle className="text-destructive opacity-50 shrink-0" size={20} />
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* Premium FAQ Section */}
            <div className="space-y-6">
                <h3 className="text-2xl font-black text-foreground">Common Inquiries</h3>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div 
                            key={index}
                            className="group rounded-2xl border border-border bg-white overflow-hidden transition-all hover:border-primary/30"
                        >
                            <button 
                                onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                                className="w-full px-8 py-6 flex items-center justify-between text-left"
                            >
                                <span className="font-bold text-foreground group-hover:text-primary transition-colors">{faq.question}</span>
                                <HiChevronDown 
                                    className={`text-muted-foreground transition-transform duration-300 ${activeIndex === index ? 'rotate-180' : ''}`} 
                                    size={20} 
                                />
                            </button>
                            <div 
                                className={`px-8 transition-all duration-300 ease-in-out ${activeIndex === index ? 'pb-8 max-h-40 opacity-100' : 'max-h-0 opacity-0'}`}
                            >
                                <p className="text-sm text-muted-foreground leading-relaxed">
                                    {faq.answer}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FullHomeCleaningInfo;
